angular.module('wbControllers').controller('TFSARRSPController', ['$scope', 'tax', ($scope, tax) => {
  $scope.$watch('options', (options) => {
    const results = {};
    options.taxRate = tax.getMarginalTaxRate(options.income, options.province);
    options.retirementTaxRate = tax.getAverageTaxRate(options.retirementIncome, options.province);
    results.rrspDeposit = options.deposit * (1 + (options.taxRate / (1 - options.taxRate)));
    results.bothDeposit = (1 + options.taxRate) * options.deposit;
    results.tfsaTaxPaid = (-options.deposit * options.taxRate) / (1 - options.taxRate);
    const realRate = (1 + options.roi) / (1 + options.inflation);
    results.tfsaFutureValue = options.deposit * (realRate ** options.years);
    results.rrspFutureValue = results.rrspDeposit * (realRate ** options.years);
    results.bothFutureValue = results.bothDeposit * (realRate ** options.years);
    results.rrspTaxPaid = -results.rrspFutureValue * options.retirementTaxRate;
    results.bothTaxPaid = -results.tfsaFutureValue * options.retirementTaxRate;
    results.interestEarned = results.futureValue - options.deposit;
    results.tfsaTaxSaved = (results.interestEarned) * options.retirementTaxRate;
    $scope.results = results;
  },
  true);

  $scope.options = {
    income: 100000,
    retirementIncome: 80000,
    province: 'BC',
    taxRate: 0.4,
    retirementTaxRate: 0.3,
    deposit: 1000,
    roi: 0.065,
    inflation: 0.025,
    years: 30,
  };
}]);
